import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  ({ breakpoints }) => ({
    selectItem: {
      whiteSpace: 'break-spaces',
      [breakpoints.up('md')]: {
        whiteSpace: 'nowrap',
      },
    },
    selectPaper: {
      maxWidth: 'calc(100% - 90px) !important',
      [breakpoints.up('md')]: {
        maxWidth: 'initial',
      },
    },
  }),
  { name: 'MarketoSelect' },
);
